module.exports = __webpack_public_path__ + "static/media/star.d930769e.svg";